module.exports = __webpack_public_path__ + "static/media/gd_logo.54c4268a.png";